import { render } from "./NewTestDialog.vue?vue&type=template&id=7eddf212&scoped=true"
import script from "./NewTestDialog.vue?vue&type=script&lang=js"
export * from "./NewTestDialog.vue?vue&type=script&lang=js"

import "./NewTestDialog.vue?vue&type=style&index=0&id=7eddf212&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eddf212"]])

export default __exports__